import { Component, Input, OnInit } from '@angular/core';
import { visibleContentAnimation } from 'src/app/animations';

@Component({
  selector: 'app-headercontent',
  templateUrl: './headercontent.component.html',
  animations: [visibleContentAnimation]
})
export class HeadercontentComponent implements OnInit {

  @Input() header: string;

  constructor() { }

  ngOnInit(): void {
  }

}
